import React from 'react'
import { Category } from './Category'
import { Shape } from './Shape'
import { ClearAllFilterButton } from '../ClearAllFilterButton'
import { VerticalSize } from './VerticalSize'
import { HorizontalSize } from './HorizontalSize'

export const FilterContainer = () => {
  return (
    <React.Fragment>
      <Shape />
      <div data-joyridestep={'filter_measurement'}>
        <VerticalSize />
        <HorizontalSize />
      </div>

      <div data-joyridestep={'filter_category'}>
        <Category />
      </div>
      <div data-joyridestep={'filter_clear'}>
        <ClearAllFilterButton />
      </div>
    </React.Fragment>
  )
}
